/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { UnintegratedPaymentFields } from './UnintegratedPaymentFields';
import {
    UnintegratedPaymentFieldsFromJSON,
    UnintegratedPaymentFieldsFromJSONTyped,
    UnintegratedPaymentFieldsToJSON,
} from './UnintegratedPaymentFields';

/**
 * 
 * @export
 * @interface PaymentMethodDto
 */
export interface PaymentMethodDto {
    /**
     * 
     * @type {string}
     * @memberof PaymentMethodDto
     */
    paymentMethod: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentMethodDto
     */
    paymentMethodCategory: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentMethodDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentMethodDto
     */
    provider: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentMethodDto
     */
    label: string;
    /**
     * 
     * @type {boolean}
     * @memberof PaymentMethodDto
     */
    isNewUnintegratedPaymentMethod: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PaymentMethodDto
     */
    isDirectSalesMethod?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PaymentMethodDto
     */
    isOpenBillMethod?: boolean;
    /**
     * 
     * @type {Array<UnintegratedPaymentFields>}
     * @memberof PaymentMethodDto
     */
    unintegratedPaymentFields?: Array<UnintegratedPaymentFields>;
    /**
     * 
     * @type {boolean}
     * @memberof PaymentMethodDto
     */
    sendNotification: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PaymentMethodDto
     */
    isUsingHub: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PaymentMethodDto
     */
    askForTip: boolean;
}

/**
 * Check if a given object implements the PaymentMethodDto interface.
 */
export function instanceOfPaymentMethodDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "paymentMethod" in value;
    isInstance = isInstance && "paymentMethodCategory" in value;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "provider" in value;
    isInstance = isInstance && "label" in value;
    isInstance = isInstance && "isNewUnintegratedPaymentMethod" in value;
    isInstance = isInstance && "sendNotification" in value;
    isInstance = isInstance && "isUsingHub" in value;
    isInstance = isInstance && "askForTip" in value;

    return isInstance;
}

export function PaymentMethodDtoFromJSON(json: any): PaymentMethodDto {
    return PaymentMethodDtoFromJSONTyped(json, false);
}

export function PaymentMethodDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentMethodDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'paymentMethod': json['paymentMethod'],
        'paymentMethodCategory': json['paymentMethodCategory'],
        'id': json['id'],
        'provider': json['provider'],
        'label': json['label'],
        'isNewUnintegratedPaymentMethod': json['isNewUnintegratedPaymentMethod'],
        'isDirectSalesMethod': !exists(json, 'isDirectSalesMethod') ? undefined : json['isDirectSalesMethod'],
        'isOpenBillMethod': !exists(json, 'isOpenBillMethod') ? undefined : json['isOpenBillMethod'],
        'unintegratedPaymentFields': !exists(json, 'unintegratedPaymentFields') ? undefined : ((json['unintegratedPaymentFields'] as Array<any>).map(UnintegratedPaymentFieldsFromJSON)),
        'sendNotification': json['sendNotification'],
        'isUsingHub': json['isUsingHub'],
        'askForTip': json['askForTip'],
    };
}

export function PaymentMethodDtoToJSON(value?: PaymentMethodDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'paymentMethod': value.paymentMethod,
        'paymentMethodCategory': value.paymentMethodCategory,
        'id': value.id,
        'provider': value.provider,
        'label': value.label,
        'isNewUnintegratedPaymentMethod': value.isNewUnintegratedPaymentMethod,
        'isDirectSalesMethod': value.isDirectSalesMethod,
        'isOpenBillMethod': value.isOpenBillMethod,
        'unintegratedPaymentFields': value.unintegratedPaymentFields === undefined ? undefined : ((value.unintegratedPaymentFields as Array<any>).map(UnintegratedPaymentFieldsToJSON)),
        'sendNotification': value.sendNotification,
        'isUsingHub': value.isUsingHub,
        'askForTip': value.askForTip,
    };
}

